import { createSvgIcon } from './createSvgIcon.js';

/** Warning triangle ! with hardcoded dark yellow color */
export const Warning24 = createSvgIcon(
  'Warning',
  24,
  'M10.03 3.66a2.25 2.25 0 0 1 3.94 0l7.74 14A2.25 2.25 0 0 1 19.74 21H4.25a2.25 2.25 0 0 1-1.97-3.34l7.75-14ZM13 17a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm-.26-7.85a.75.75 0 0 0-1.5.1v4.5l.02.1a.75.75 0 0 0 1.49-.1v-4.5l-.01-.1Z',
  '#b88700',
);
